import React, { Component } from 'react';
import { withRouter } from 'hay-core-react';
import { createSearchParams, Navigate } from 'react-router';
import { UtilService } from 'hay-core-react';
import RotaService from '../service/RotasService';

const CHAVE_TENTATIVA = 'deepLinkTentativa';
// Janela de tolerância do guard de retry — cobre o round-trip real (PaginaNaoExiste -> /login ->
// autorizar() -> volta pro destino), sem bloquear uma visita/F5 legítima e posterior à mesma URL.
// sessionStorage sobrevive a reloads (só é limpo ao fechar a aba), então sem essa janela o guard
// "gasta" a única tentativa na primeira visita e nunca mais tenta de novo na mesma sessão.
const JANELA_TENTATIVA_MS = 5000;

class PaginaNaoExiste extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const caminho = '/' + (this.props.params['*'] || '');
        const destino = caminho + window.location.search;
        const conheceRota = Object.values(RotaService).some(
            (cfg) => caminho === cfg.rota || caminho.startsWith(cfg.rota + '/')
        );
        const auth = UtilService.getLocalStorage('auth');
        // try/catch cobre valor de formato antigo (string simples, sem timestamp) que pode ter
        // ficado salvo no sessionStorage de uma aba aberta antes desta mudança.
        let tentativaAnterior = null;
        try {
            tentativaAnterior = JSON.parse(sessionStorage.getItem(CHAVE_TENTATIVA));
        } catch { /* formato antigo/inválido -> trata como nenhuma tentativa anterior */ }
        const jaTentouEsseDestino = tentativaAnterior?.destino === destino
            && (Date.now() - tentativaAnterior.timestamp) < JANELA_TENTATIVA_MS;

        if (auth?.token && conheceRota && !jaTentouEsseDestino) {
            // Rota real, só ainda não registrada (permissões carregando) — preserva e tenta de
            // novo após login, UMA vez só dentro da janela acima. O guard evita loop infinito
            // quando o motivo real é falta de permissão pro recurso/ação, não uma corrida de
            // carregamento — mas expira sozinho, permitindo retry numa visita/reload seguinte.
            sessionStorage.setItem(CHAVE_TENTATIVA, JSON.stringify({ destino, timestamp: Date.now() }));
            const search = '?' + createSearchParams({ destino }).toString();
            return <Navigate to={{ pathname: '/login', search }} replace />;
        }

        sessionStorage.removeItem(CHAVE_TENTATIVA);
        // Rota desconhecida (typo), já tentou uma vez sem sucesso, ou usuário anônimo -> padrão.
        return <Navigate to={{ pathname: auth?.token ? '/dashboard' : '/login' }} replace />;
    }
}
export default withRouter(PaginaNaoExiste);
